import React from 'react'
import Loader from 'components/Loader'
import styled from 'styled-components'

const Overlay = styled.span`
  position: absolute;
  display: block;
  inset: 0;
  z-index: 4;
  cursor: default;
  background-color: rgba(0,0,0,0.1);
`

const BusyOverlay: React.FC<React.HTMLProps<HTMLSpanElement>> = ({ style, ...props }) => {
  return (
    <Overlay
      {...props}
    >
      <Loader absoluteCenter style={{ zIndex: 3 }} />
    </Overlay>
  )
}

export default BusyOverlay

